(function () {
/**
 * Close details element when pressing the escape key or clicking outside of it.
 * Default behavior of the details element is to close when clicking again on the summary element.
 * @param {string} detailsId - The id of the details element to close.
 */ function $746bcb867c663999$var$closeDetailsWithEsc(detailsId) {
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape") document.getElementById(detailsId).removeAttribute("open");
    });
}
function $746bcb867c663999$var$closeDetailsOnClickOutside(detailsId) {
    document.addEventListener("click", (event)=>{
        if (!document.getElementById(detailsId).contains(event.target)) document.getElementById(detailsId).removeAttribute("open");
    });
}
$746bcb867c663999$var$closeDetailsWithEsc("language-selector");
$746bcb867c663999$var$closeDetailsOnClickOutside("language-selector");

})();
//# sourceMappingURL=index.js.map
